// Sesión con el servidor (Supabase Auth), separada de la sesión local del dispositivo: se puede
// estar usando la app (sesión local) sin sesión en el servidor, por ejemplo si entró sin conexión
// o si la sesión del servidor venció y no se pudo renovar. En ese caso nada se envía ni se
// consulta al servidor, así que la app tiene que avisarlo.
import { useSyncExternalStore } from 'react';
import { recordTiming } from './timings.ts';
import { supabase } from './supabase.ts';

/** undefined = todavía no se sabe; null = sin sesión; string = id del usuario. */
let serverUserId: string | null | undefined;
const listeners = new Set<() => void>();
const set = (id: string | null) => {
  if (id === serverUserId) return;
  serverUserId = id;
  for (const l of listeners) l();
};

void supabase.auth.getSession().then(({ data }) => set(data.session?.user.id ?? null));
supabase.auth.onAuthStateChange((event, session) => {
  // Queda anotado en «Tiempos recientes» (Sincronización) para diagnosticar.
  if (event === 'SIGNED_OUT') recordTiming('Se cerró la sesión con el servidor (al salir o por vencimiento)', 0, true);
  set(session?.user.id ?? null);
});

export function useServerUserId(): string | null | undefined {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => serverUserId,
  );
}
